import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import SuperAdmin from '../superadmin/Home';

function Router() {
  return (
    <Routes>
      <Route exact path="/superadmin/home" element={<SuperAdmin />} />
    </Routes>
  );
}

export default Router;
